/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-title-font-size',
  templateUrl: './theme-option-tooltips-title-font-size.component.html',
  styleUrls: ['./theme-option-tooltips-title-font-size.component.css']
})
export class ThemeOptionTooltipsTitleFontSizeComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_titleFontSize';

  constructor() {}
  
  receiveValue(value: number) {
    this.themeOptions.setOption('tooltips_titleFontSize', value);
  }

}
